import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import PropTypes from 'prop-types';
import { Flex } from 'rebass/styled-components';

import { LinkedInSignInButton } from '../../atoms/linkedInSignInButton';
import { GoogleSignInButton } from '../../atoms/googleSignInButton';

export const SocialOAuthButtons = ({
  mode,
  params,
  onSuccess,
  onError,
  isInvite,
  disableLinkedIn,
  isLoading,
  ...props
}) => (
  <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
    <Flex flexDirection="column" sx={{ gap: '8px' }} {...props}>
      {!disableLinkedIn && (
        <LinkedInSignInButton isInvite={isInvite} mode={mode} params={params} onSuccess={onSuccess} onError={onError} />
      )}
      <GoogleSignInButton
        isLoading={isLoading}
        isInvite={isInvite}
        mode={mode}
        params={params}
        onSuccess={onSuccess}
        onError={onError}
      />
    </Flex>
  </GoogleOAuthProvider>
);

SocialOAuthButtons.propTypes = {
  mode: PropTypes.oneOf(['sign-in', 'sign-up']),
  params: PropTypes.object,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  isInvite: PropTypes.bool,
  disableLinkedIn: PropTypes.bool,
  isLoading: PropTypes.bool,
};

SocialOAuthButtons.defaultProps = {
  mode: 'sign-in',
  params: {},
  onSuccess: null,
  onError: null,
  isInvite: false,
  disableLinkedIn: false,
  isLoading: false,
};
